import React from "react";
import { useNavigate } from "react-router-dom";

export default function TerugNaarHomeButton() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center mt-6">
      <button
        onClick={() => navigate("/")}
        className="inline-flex items-center px-6 py-3 rounded-2xl bg-gray-100 text-gray-800 border border-gray-300 hover:bg-gray-200 transition"
      >
        ← Terug naar home
      </button>
    </div>
  );
}
